import Swal from "sweetalert2";

/**
 * Skip show/hide animations + avoid body scrollbar padding (layout reflow) for snappy open/close.
 */
const SWAL_SNAPPY = {
  scrollbarPadding: false,
  showClass: {
    backdrop: "swal2-noanimation",
    popup: "swal2-noanimation",
    icon: "swal2-noanimation",
  },
  hideClass: {
    backdrop: "swal2-noanimation",
    popup: "swal2-noanimation",
    icon: "swal2-noanimation",
  },
};

function escHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Legacy-style bordered grid (Lot / Qty / Price / Client / Order type). */
function orderSummaryTable(rows) {
  const body = rows
    .filter(([, v]) => v != null && String(v).trim() !== "")
    .map(
      ([label, val]) =>
        `<tr><td>${escHtml(label)}</td><td>${escHtml(String(val))}</td></tr>`
    )
    .join("");
  return `<table class="fx-swal-order-grid" role="presentation">${body}</table>`;
}

/** Place immediately — no Confirm Order step (disabled permanently). */
export async function confirmQuickOrder() {
  return { isConfirmed: true, isDenied: false, isDismissed: false };
}

/** Close position — table summary + Cancel / confirm (gold accent, legacy). */
export function confirmClosePosition({ lot, qty, price }) {
  const rows = [
    ["Lot", lot],
    ["Qty", qty],
    ["Price", price],
  ];
  return Swal.fire({
    title: "Confirm Close",
    icon: false,
    html: orderSummaryTable(rows),
    showCancelButton: true,
    focusCancel: true,
    confirmButtonText: "Yes, Close it!",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#885b24",
    cancelButtonColor: "#f43f5e",
    width: "min(92vw, 380px)",
    customClass: {
      container: "swal2-on-top",
      popup: "swal-fx-confirm swal-fx-confirm-order swal-fx-confirm-close",
    },
    buttonsStyling: true,
    ...SWAL_SNAPPY,
  });
}

export function confirmRolloverPositions(count) {
  const n = Number(count) || 0;
  return Swal.fire({
    title: "Confirm Rollover",
    icon: false,
    text: n === 1 ? "Rollover this position?" : `Rollover ${n} selected positions?`,
    showCancelButton: true,
    focusCancel: true,
    confirmButtonText: "Yes, Rollover it!",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#885b24",
    cancelButtonColor: "#f43f5e",
    customClass: {
      container: "swal2-on-top",
      popup: "swal-fx-confirm swal-fx-confirm-order",
    },
    buttonsStyling: true,
    width: "min(92vw, 380px)",
    ...SWAL_SNAPPY,
  });
}

export function alertSelectPositionFirst() {
  return Swal.fire({
    title: "No selection",
    text: "Please select at least one position.",
    icon: false,
    confirmButtonText: "OK",
    confirmButtonColor: "#16a34a",
    customClass: {
      container: "swal2-on-top",
      popup: "swal-fx-confirm",
    },
    ...SWAL_SNAPPY,
  });
}
